import type { ResourceConfig } from "../types";

export const classSessionConfig = {
  displayName: "班期",
  category: "class-session",
  permissions: {
    "read:all": {
      label: "查看所有班期",
      description: "可以查看系统中所有班期的信息",
    },
    "write:all": {
      label: "编辑所有班期",
      description: "可以编辑系统中所有班期的信息",
    },
    "read:assigned": {
      label: "查看自己负责的班期",
      description: "只能查看分配给自己的班期信息",
    },
    "write:assigned": {
      label: "编辑自己负责的班期",
      description: "只能编辑分配给自己的班期信息",
    },
  },
  scopeStrategy: "byEnrollmentStaff",
  navigation: {
    path: "/class-sessions",
    label: "班期",
    icon: "Calendar" as const,
    requiredPermissions: ["read:all", "read:assigned"] as const,
    // ✅ 移除硬编码排除，让权限系统决定可见性
    // 如果教练主管有 class-session:read:all 权限，就应该能看到导航
    order: 20,
  },
} satisfies ResourceConfig;
